import { GraphPanel } from 'z3k-config';
export function getGraphPanelName(type) {
    switch (type) {
        case GraphPanel.Type.Climatic:
            return 'Climatic';
        case GraphPanel.Type.ML_753:
            return 'МЛ-753';
        default:
            return undefined;
    }
}
